import clsx from 'clsx';

import {
  ActionIconProps,
  ActionIconStylesNames,
  MantineTheme,
  rem
} from '@mantine/core';

import commonStylesClasses from '../styles/Common.module.css';

import actionIconClasses from './ActionIcon.module.css';

export const DefaultActionIconProps: Partial<ActionIconProps> = {
  radius: rem('6px')
};

const sizes = {
  xs: {
    size: 20
  },
  sm: {
    size: 24
  },
  md: {
    size: 28
  },
  lg: {
    size: 32
  },
  xl: {
    size: 40
  }
};

export const ActionIconVarsResolver: (
  theme: MantineTheme,
  props: ActionIconProps
) => any = (theme, props) => {
  if (props.size === 'xs') {
    return {
      root: {
        '--ai-size': rem(sizes?.xs?.size)
      }
    };
  } else if (props.size === 'sm') {
    return {
      root: {
        '--ai-size': rem(sizes?.sm?.size)
      }
    };
  } else if (props.size === 'md') {
    return {
      root: {
        '--ai-size': rem(sizes?.md?.size)
      }
    };
  } else if (props.size === 'lg') {
    return {
      root: {
        '--ai-size': rem(sizes?.lg?.size)
      }
    };
  } else if (props.size === 'xl') {
    return {
      root: {
        '--ai-size': rem(sizes?.xl?.size)
      }
    };
  }
};

export const ActionIconOverrideClassNames: (
  theme: MantineTheme,
  props: ActionIconProps
) => Partial<Record<ActionIconStylesNames, string>> = (theme, props) => {
  return {
    root: clsx(actionIconClasses.root, {
      [commonStylesClasses.primaryButton]: props.color === 'primary',
      [commonStylesClasses.secondaryButton]: props.color === 'secondary',
      [commonStylesClasses.successButton]: props.color === 'success',
      [commonStylesClasses.dangerButton]: props.color === 'danger'
    })
  };
};
